import { useRef, useMemo } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import useUiuxStore from "src/store/useUiuxStore";

import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_KSK1070_R01 } from "./Content_KSK1070_R01";
import { Info_KSK1070_R01 } from "./Info_KSK1070_R01";
import { useKSK1070_R01Store } from "./Store_KSK1070_R01";
import { AgGridReact } from "ag-grid-react";
import { KSK1070_R01DetailDto, KSK1070_R01HeaderDto, KSK1070_R01LotDto } from "./Dto_KSK1070_R01";
import { DetailTable_KSK1070_R01 } from "./DetailTable_KSK1070_R01";
import { LotTable_KSK1070_R01 } from "./LotTable_KSK1070_R01";


export const Container_KSK1070_R01 = () => {

	const {
		syncInitialData,
	} = useKSK1070_R01Store();

	const { tabList, setMessage } = useUiuxStore();

	const gridRef = useRef<AgGridReact<KSK1070_R01HeaderDto>>(null);
	const lotGridRef = useRef<AgGridReact<KSK1070_R01LotDto>>(null);
	const detailGridRef = useRef<AgGridReact<KSK1070_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoAreaRef = useRef<HTMLDivElement>(null);
	const bottomContainerRef = useRef<HTMLDivElement>(null);
	const detailAreaRef = useRef<HTMLDivElement>(null);
	const isVResizing = useRef(false);
	const isLotResizing = useRef(false);

	const V_RESIZER = {
		code: 'KSK1070_R01',
		type: 'height',
		storageKey: 'KSK1070_R01-info-split-height',
		min: 15,
		max: 70,
		default: 55,
	} as const;

	const {
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef,
		infoRef: infoAreaRef,
	});

	const RESIZER_LOT = {
		code: 'KSK1070_R01_lot',
		type: 'width',
		storageKey: 'KSK1070_R01-detail-lot-split-width',
		min: 30,
		max: 80,
		default: 65,
	} as const;

	const {
		splitValue: lotSplitValue,
		handleMouseDown: handleLotMouseDown,
	} = useMouseContent({
		resizer: RESIZER_LOT,
		isResizing: isLotResizing,
		containerRef: bottomContainerRef,
		infoRef: detailAreaRef,
	});

	const {
		clickable, setClickable,
		handleExcelClick,
		defaultKSK1070_R01HeaderRow,
		defaultKSK1070_R01DetailRow,
		defaultKSK1070_R01LotRow,
		initContainerData,
		handleDeleteClick,
		handleInsertClick,
		handleSaveClick,
		handleFetchDetailList,
		handleFetchLotList,
		getWmsOrderFieldHandlers,
		handleSearchClick,
	} = Content_KSK1070_R01({
		gridRef,
		lotGridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing: isVResizing,
	});

	const headerDefaultRow = useMemo(() => defaultKSK1070_R01HeaderRow(), [defaultKSK1070_R01HeaderRow]);
	const detailDefaultRow = useMemo(() => defaultKSK1070_R01DetailRow(), [defaultKSK1070_R01DetailRow]);
	const lotDefaultRow = useMemo(() => defaultKSK1070_R01LotRow(), [defaultKSK1070_R01LotRow]);

	useMemo(() => { syncInitialData(); }, []);

	return <div className={`content-container`}>
		<Actionbar
			onFetchClick={handleSearchClick}
			onCreateClick={() => {}}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={() => {}}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0 flex-col" ref={containerRef}>
			{/* 상단: Info */}
			<div
				className="w-full max-w-full min-h-0 overflow-hidden"
				style={{ height: `${vSplitValue}%` }}
				ref={infoAreaRef}
			>
				<div className="h-full max-h-full overflow-y-auto border border-gray-300 min-w-0 pt-[12px] pl-[12px] pr-[12px] pb-[6px]">
					<Info_KSK1070_R01
						editable={false}
						defaultKSK1070_R01HeaderRow={headerDefaultRow}
						getWmsOrderFieldHandlers={getWmsOrderFieldHandlers}
						onSearchClick={handleSearchClick}
						handleFetchDetailList={handleFetchDetailList}
					/>
				</div>
			</div>

			{/* 상하 리사이저 */}
			<div
				className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300 shrink-0"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown('UD', e.nativeEvent)}
			/>

			{/* 하단: Detail | Lot */}
			<div
				className="w-full min-h-0 flex gap-[4px]"
				style={{ height: `${100 - vSplitValue}%` }}
				ref={bottomContainerRef}
			>
				<div
					className="h-full max-h-full flex flex-col min-h-0 min-w-0"
					style={{ width: `${lotSplitValue}%` }}
					ref={detailAreaRef}
				>
					<DetailTable_KSK1070_R01
						detailGridRef={detailGridRef}
						defaultKSK1070_R01DetailRow={detailDefaultRow}
						handleFetchLotList={handleFetchLotList}
					/>
				</div>

				<div
					className="w-[6px] h-full bg-gray-100 cursor-col-resize hover:bg-gray-300 shrink-0"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleLotMouseDown('LR', e.nativeEvent)}
				/>

				<div
					className="h-full max-h-full flex flex-col min-h-0 min-w-0"
					style={{ width: `${100 - lotSplitValue}%` }}
				>
					<LotTable_KSK1070_R01
						lotGridRef={lotGridRef}
						defaultKSK1070_R01LotRow={lotDefaultRow}
						clickable={clickable}
						setClickable={setClickable}
						handleInsertClick={handleInsertClick}
					/>
				</div>
			</div>
		</div>
	</div>
}
